import React from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import isChromatic from 'chromatic/isChromatic';

import { ChecklistIcon } from '@motorway/mw-highway-code';
import { Hyperlink } from '@motorway/mw-highway-code/alpha';

import { ACCOUNT_SETTINGS_COMPANY_INFORMATION_LINK } from 'Components/pages/AccountSettings/AccountSettings.consts';
import { SNOWPLOW_EVENTS } from 'Services/analytics/analytics.const';
import { motorwayPayPageEvents } from 'Services/analytics/events/paymentEvents/motorwayPayPageEvents';

import { FAQExpandable } from './FAQExpandable';
import type { FAQSectionProps } from './FAQSection';

export const FAQSecondSection: React.FC<FAQSectionProps> = ({ isLoggedOut }) => {
	return (
		<FAQExpandable
			content={
				<>
					<p>
						First, you need to complete a{' '}
						{isLoggedOut ? (
							'Know Your Customer'
						) : (
							<Hyperlink
								as="a"
								href={ACCOUNT_SETTINGS_COMPANY_INFORMATION_LINK}
								label="KYC (Know Your Customer)"
								onClick={() => {
									motorwayPayPageEvents<{
										label: string;
									}>({
										customData: {
											label: 'kyc_form_link',
										},
										name: 'Link clicked',
										schemaName: SNOWPLOW_EVENTS.CLICK.SCHEMA,
										version: SNOWPLOW_EVENTS.CLICK.VERSION,
									});
								}}
								target="_blank"
							/>
						)}{' '}
						form (also known as a KYC check). This is a regulatory requirement that asks you to provide some standard
						info about your business.
					</p>
					<p>Once the KYC check is complete, we’ll get in touch to finish signing you up.</p>
				</>
			}
			defaultIsExpanded={Boolean(isChromatic())}
			heading={'How do I join?'}
			icon={ChecklistIcon}
			id="secondExpandable"
		/>
	);
};
